import browser_1 from './browser_1.png';
import hero_admin_browser from './hero_admin_browser.webp';
import hero_bg from './hero_bg.webp';
import hero_bg_2 from './hero_bg_2.png';
import how_it_work_bg from './how_it_work_bg.png';
import subtract_2_splash from './subtract_2_splash.svg';
import subtract_3 from './subtract_3.svg';

export const backgrounds = {
  browser_1: browser_1.src,
  hero_bg: hero_bg.src,
  hero_bg_2: hero_bg_2.src,
  how_it_work_bg: how_it_work_bg.src,
  subtract_2_splash,
  subtract_3,
  hero_admin_browser: hero_admin_browser.src,
};
